import config from "../config";
const API_USER_INFO = config.api.endpoints.USER_INFO;
const privateSchoolIds = config.app.privateSchoolIds;

/**
 * Fetch user info from the API (requires auth token)
 */
export const fetchUserInfo = async (token: string) => {
  if (!token) {
    throw new Error("Auth token is required to fetch user info.");
  }

  try {
    const response = await fetch(API_USER_INFO, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      let details = '';
      try {
        const errBody = await response.json();
        details = String(errBody?.details ?? errBody?.message ?? '').trim();
      } catch {
        // ignore non-JSON error bodies
      }
      const suffix = details ? ` — ${details}` : '';
      throw new Error(`Failed to fetch user info: ${response.status} ${response.statusText}${suffix}`);
    }

    const result = await response.json();
    if (result.students?.studentsList?.length > 0) {

      // schoolName in services & context and schoolFullName in component
      result.students.schoolName = [
      ...new Set(result.students.studentsList
      .map((student: any) => student.schoolName || "UnknownSchool") )
      ].join(", ");

      // All students will belong to the same school
      const firstStudentCommon = result.students.studentsList[0];
      result.students.schoolShortName = firstStudentCommon.schoolShortName || "";

      // Set schoolTypeConfigured formatted based on whether any match private school list
      const loggedInUserSchoolId = result.user.schoolId;
      const hasPrivateSchool = privateSchoolIds.includes(loggedInUserSchoolId);
      result.students.schoolTypeConfigured = hasPrivateSchool ? "private" : "public";
    }
    return result;
  } catch (error) {
    console.error("Error while fetching user info:", error);
    return null;
  }
};
